/* eslint-disable max-depth */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import { Obstruction } from '../obstruction.class';
import islandAssetMap from '../../data/island-asset.map.json';
import { IslandAssetData, IslandAssetProperties } from '../types';

export const getSkuSizeDetailsCfn = (island: Obstruction): [string, IslandAssetProperties] => {
	const assetMap: Record<string, IslandAssetData> = islandAssetMap;
	const width = island.size.width ?? 0;
	let key: string = null;
	let assetData: IslandAssetProperties = null;
	let finish = 'STANDARD'
	let islandType: string = island.type

	// RTAP-P3-MG - Pizza Stand
	// RTAC-K3-MW - Asado Stand !free standing

	// Note: ObstructionType does not include SMOKER - this check is retained from the islands version
	if ((island.type as string) === 'SMOKER' && island.size.height === 16) islandType = 'ASADO';

	// check material for plank charcoal
	if (island.surround.material === 'shiplap' && island.surround.texture === 'Shiplap_Gray_Tile.jpg') finish = 'CHARCOAL';

	if (island.surround.displayName === 'Slat - Walnut' || island.surround.displayName === 'Slat - Charcoal' || island.surround.displayName === 'Slat - Bright') finish = 'SLAT';

	// prices for standard islands
	for (const size in assetMap[finish]) {
		if (size) {
			key = size;
			assetData = assetMap[finish][size]
			if (width > assetData.min && width <= assetData.max) break;
		}
	}

	return [key, assetData];
}
